import frequencia_parques from "../../../mockups/paineis/Frame 73_transparente.png"

export default function FrequenciaParques({ getImagem }) {
  return (
    <div className="px-16 py-10 flex justify-center">
      {/* <div className="rounded-3xl overflow-hidden bg-white">
        <header className="bg-blue text-white p-6 text-center">
          <p className="text-4xl font-bold">
            Frequência nos parques urbanos de São Paulo
          </p>
        </header>

        <div className="border-2 border-t-0 border-grayLight rounded-b-3xl p-8">
          <div className="flex gap-10 items-center">
            <div className="w-1/2">
              <img
                src={getImagem(0)}
                alt=""
                className="w-full h-[330px] object-cover rounded-3xl"
              />
            </div>

            <div className="relative w-1/2 border-2 border-grayLight rounded-3xl p-8 pt-14">
              <div className="absolute -top-5 left-8 px-6 py-2 rounded-full bg-blue text-white">
                <p className="text-2xl font-bold">Curiosidade</p>
              </div>

              <p className="text-2xl leading-relaxed text-blue font-semibold">
                Nas últimas semanas, a frequência no Parque do Carmo vem
                superando a do Parque Ibirapuera, com mais de 500 mil visitantes
                em um dia!
              </p>
            </div>
          </div>
        </div>
      </div> */}
      <img src={frequencia_parques} alt="" />
    </div>
  );
}
